const getEmployeeLetter = (name: string): string => {
  if (name) {
    const [fname, lname] = name.split(" ");
    return `${fname[0]}${lname[0]}`;
  }
  return "";
};

export { getEmployeeLetter };
